var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1808 0H13.0492C5.93145 0 0 5.93221 0 13.0509V42.9492C0 50.3051 5.93145 56 13.0492 56H42.9439C50.2989 56 55.9931 50.0678 55.9931 42.9492V13.0509C56.2304 5.69492 50.2986 0 43.1808 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8106 19.8105L15.8105 19.8106C12.6015 23.0196 12.6015 28.2226 15.8105 31.4316L22.567 38.188C25.776 41.3971 30.979 41.3971 34.188 38.188L34.1881 38.188C37.3971 34.9789 37.3971 29.776 34.1881 26.5669L27.4316 19.8105C24.2226 16.6015 19.0196 16.6015 15.8106 19.8105Z",
    fill: "white",
    stroke: "#003144",
    strokeWidth: 5.56511
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9424 19.8106L40.9424 19.8105C37.7333 16.6015 32.5304 16.6015 29.3213 19.8105L22.5649 26.567C19.3558 29.776 19.3558 34.979 22.5649 38.188L22.5649 38.1881C25.774 41.3971 30.9769 41.3971 34.186 38.1881L40.9424 31.4316C44.1515 28.2226 44.1515 23.0196 40.9424 19.8106Z",
    fill: "white",
    stroke: "#4285F4",
    strokeWidth: 5.56511
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2941 28.4584C33.8614 30.0257 36.4023 30.0256 37.9695 28.4584C39.5368 26.8912 39.5368 24.3502 37.9695 22.783C36.4023 21.2158 33.8614 21.2158 32.2941 22.783C30.7269 24.3502 30.7269 26.8912 32.2941 28.4584Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthConnect);
export default __webpack_public_path__ + "static/media/health-connect.f18af64e3d39c56eb69d4d8b6289cf44.svg";
export { ForwardRef as ReactComponent };